export const BUDGET_SHOP_REQUEST = "BUDGET_SHOP_REQUEST";
export const BUDGET_SHOP_SUCCESS = "BUDGET_SHOP_SUCCESS";
export const BUDGET_SHOP_FAIL = "BUDGET_SHOP_FAIL";
export const BUDGET_SHOP_SEARCH_REQUEST = "BUDGET_SHOP_SEARCH_REQUEST";
export const BUDGET_SHOP_SEARCH_SUCCESS = "BUDGET_SHOP_SEARCH_SUCCESS";
export const BUDGET_SHOP_SEARCH_FAIL = "BUDGET_SHOP_SEARCH_FAIL";
